import { route, string } from 'react-router-typesafe-routes/dom'
const companyOnly = { companyId: string().defined() }

export const IMPORTS_ROUTES = {
  importHomeCards: route('et/company/:companyId/importsModule', {
    params: companyOnly,
  }),
}
